export const API = {
	tickets: {
		create: `/ticket`,
		edit: `/ticket/`,
		delete: `/ticket/`,
		list: `/ticket`,
		getByDateRange: `/ticket/date-range`,
		generatePDF: `/ticket/generate-pdf`,
		report: `/ticket/report`,
	},
	applications: {
		create: `/application`,
		edit: `/application/`,
		delete: `/application/`,
		list: `/application`,
	},
	auth: {
		login: `/user/login`,
		check2FA: `/user/check2FA`,
	},
	users: {
		profile: `/user/profile`,
		create: `/user/register/`,
		edit: `/user/`,
		delete: `/user/`,
		list: `/user`,
	},
	alerts: {
		delete: `/alert/`,
		list: `/alert`,
	},
	contracts: {
		list: `/contracts`,
		hours: (id) => `/contracts/${encodeURIComponent(id)}/hours`,
	},
	customers: {
		search: `/customers`,
	},
};
